import { Gavel } from "lucide-react";

const Box = ({ label }) => (
  <div className="flex items-center gap-3">
    <span className="h-6 w-6 shrink-0 border-2 border-[#2B1D12]" />
    <span className="font-display text-lg">{label}</span>
  </div>
);

const Ballot = ({ b, verdict, n }) => (
  <div className="break-inside-avoid rounded-xl border-2 border-dashed border-[#9A5B1E]/60 bg-[#F3E6D0] p-6 text-[#2B1D12] print:rounded-none" data-testid={`ballot-card-${n}`}>
    <div className="flex items-start justify-between gap-4">
      <div>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#9A5B1E]">Ballot · {n} of {b.quantity}</p>
        <h3 className="mt-2 font-display text-2xl italic">{verdict.title || "The Verdict"}</h3>
      </div>
      <Gavel className="h-7 w-7 text-[#9A5B1E]" />
    </div>
    <p className="mt-4 font-display text-xl">{verdict.intro || "Was justice served?"}</p>
    <div className="mt-5 space-y-3">
      <Box label="Yes, justice was served" />
      <Box label="No, justice was not served" />
    </div>
    <div className="mt-6 border-t border-[#9A5B1E]/40 pt-3 font-mono text-[11px] text-[#5A4433]">
      <div className="flex flex-wrap justify-between gap-2"><span>{b.code}-{n}</span><span>{b.night_label ? `${b.night_label} · ` : ""}{b.night_date_display}</span></div>
      <p className="mt-1">Bring this card to the show and cast your vote.</p>
    </div>
  </div>
);

export const BallotCards = ({ b, verdict }) => (
  <section className="mt-14 print:mt-0 print:break-before-page" data-testid="ballot-cards">
    <div className="print:hidden">
      <p className="eyebrow">For The Verdict</p>
      <h2 className="mt-2 font-display text-2xl text-[#1F1B17]">Your ballot {b.quantity > 1 ? "cards" : "card"}</h2>
      <p className="mt-2 text-sm text-[#6B6157]">One for each guest in your party. Print them and bring them along.</p>
    </div>
    <div className="mt-6 grid gap-5 sm:grid-cols-2 print:grid-cols-2">
      {Array.from({ length: b.quantity }, (_, i) => <Ballot key={i} b={b} verdict={verdict} n={i + 1} />)}
    </div>
  </section>
);
